// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./~/@automattic/dops-components/client/components/button/style.scss
 ** module id = 211
 ** module chunks = 1
 **/